import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Veiculos from './pages/Veiculos';
import VeiculoForm from './pages/VeiculoForm';
import Usuarios from './pages/Usuarios';
import UsuarioForm from './pages/UsuarioForm';
import ConfirmarCadastro from './pages/ConfirmarCadastro';
import RedefinirSenha from './pages/RedefinirSenha';
import RecuperarSenha from './pages/RecuperarSenha';
import WhatsAppChat from './pages/WhatsAppChat';
import Contatos from './pages/Contatos';
import Configuracoes from './pages/Configuracoes';
import ConfiguracaoForm from './pages/ConfiguracaoForm';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import Administradores from './pages/Administradores';
import AdministradorForm from './pages/AdministradorForm';
import RedirectAuth from './components/RedirectAuth';
import ClienteSobre from './pages/ClienteSobre';
import ClienteSobreForm from './pages/ClienteSobreForm';
import Planos from './pages/Planos';
import PlanoForm from './pages/PlanoForm';
import Recursos from './pages/Recursos';
import RecursoForm from './pages/RecursoForm';
import Contratos from './pages/Contratos';
import ContratoForm from './pages/ContratoForm';
import ContratoDetalhes from './pages/ContratoDetalhes';
import ContratosDashboard from './pages/ContratosDashboard';
import DashboardCliente from './pages/DashboardCliente';
import DashboardCreditos from './pages/DashboardCreditos';
import ComprarCreditos from './pages/ComprarCreditos';
import UpgradePlano from './pages/UpgradePlano';
import SelecionarCartaoUpgrade from './pages/SelecionarCartaoUpgrade';
import KeysApis from './pages/KeysApis';
import KeyApiForm from './pages/KeyApiForm';
import CadastrarCartaoPublico from './pages/CadastrarCartaoPublico';
import MeusCartoes from './pages/MeusCartoes';
import CartaoForm from './pages/CartaoForm';
import FunilProspeccao from './pages/FunilProspeccao';
import FunilProspeccaoForm from './pages/FunilProspeccaoForm';
import MensagensEtapa from './pages/MensagensEtapa';
import MensagemEtapaForm from './pages/MensagemEtapaForm';
import Leads from './pages/Leads';
import LeadsPrepararMensagens from './pages/LeadsPrepararMensagens';
import LeadsConfirmarEnvio from './pages/LeadsConfirmarEnvio';
import LeadForm from './pages/LeadForm';
import Campanhas from './pages/Campanhas';
import CampanhaForm from './pages/CampanhaForm';
import ParametrosIA from './pages/ParametrosIA';
import ParametroIAForm from './pages/ParametroIAForm';
import ConfiguracaoIA from './pages/ConfiguracaoIA';
import ConfiguracaoIAForm from './pages/ConfiguracaoIAForm';
import ParametrosWhatsapp from './pages/ParametrosWhatsapp';
import ParametroWhatsappForm from './pages/ParametroWhatsappForm';

/** Wrapper que remonta o LeadForm ao trocar de lead (key={id}), evitando contatos de outro lead na edição */
function LeadFormEditar() {
  const { id } = useParams();
  return <LeadForm key={id} />;
}

function App() {
  return (
    <Routes>
      {/* Rota de login - acessível apenas para usuários não autenticados */}
      <Route path="/login" element={<Login />} />
      
      {/* Rota pública de confirmação de cadastro */}
      <Route path="/confirmar-cadastro/:uuid" element={<ConfirmarCadastro />} />
      
      {/* Rota pública de recuperação de senha */}
      <Route path="/recuperar-senha" element={<RecuperarSenha />} />
      
      {/* Rota pública de redefinição de senha */}
      <Route path="/redefinir-senha/:uuid" element={<RedefinirSenha />} />
      
      {/* Rota pública de cadastro de cartão */}
      <Route path="/cadastrar-cartao/:token" element={<CadastrarCartaoPublico />} />
      
      {/* Rotas protegidas */}
      <Route path="/meus-cartoes" element={
        <ProtectedRoute>
          <MeusCartoes />
        </ProtectedRoute>
      } />
      
      <Route path="/meus-cartoes/novo" element={
        <ProtectedRoute>
          <CartaoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/meus-cartoes/:id/editar" element={
        <ProtectedRoute>
          <CartaoForm />
        </ProtectedRoute>
      } />
      <Route path="/veiculos" element={
        <ProtectedRoute>
          <Veiculos />
        </ProtectedRoute>
      } />
      
      <Route path="/veiculos/novo" element={
        <ProtectedRoute>
          <VeiculoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/veiculos/:id/editar" element={
        <ProtectedRoute>
          <VeiculoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/usuarios" element={
        <ProtectedRoute requireAdmin={true}>
          <Usuarios />
        </ProtectedRoute>
      } />
      
      <Route path="/usuarios/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <UsuarioForm />
        </ProtectedRoute>
      } />
      
      <Route path="/usuarios/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <UsuarioForm />
        </ProtectedRoute>
      } />

      {/* Setup: primeiro administrador (rota pública) */}
      <Route path="/setup/primeiro-admin" element={<AdministradorForm primeiroAdmin />} />

      <Route path="/administradores" element={
        <ProtectedRoute requireAdmin={true}>
          <Administradores />
        </ProtectedRoute>
      } />

      <Route path="/administradores/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <AdministradorForm />
        </ProtectedRoute>
      } />

      <Route path="/administradores/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <AdministradorForm />
        </ProtectedRoute>
      } />
      
      <Route path="/whatsapp/conversas" element={
        <ProtectedRoute>
          <WhatsAppChat />
        </ProtectedRoute>
      } />
      
      <Route path="/whatsapp/contatos" element={
        <ProtectedRoute>
          <Contatos />
        </ProtectedRoute>
      } />
      
      <Route path="/configuracoes" element={
        <ProtectedRoute requireAdmin={true}>
          <Configuracoes />
        </ProtectedRoute>
      } />
      
      <Route path="/configuracoes/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <ConfiguracaoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard/configuracoes" element={
        <ProtectedRoute requireAdmin={true}>
          <Dashboard />
        </ProtectedRoute>
      } />
      
      <Route path="/configuracoes/:uuid/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <ConfiguracaoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/planos" element={
        <ProtectedRoute requireAdmin={true}>
          <Planos />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/planos/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <PlanoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/planos/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <PlanoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/recursos" element={
        <ProtectedRoute requireAdmin={true}>
          <Recursos />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/recursos/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <RecursoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/recursos/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <RecursoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/contratos" element={
        <ProtectedRoute requireAdmin={true}>
          <Contratos />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/contratos/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <ContratoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/contratos/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <ContratoForm />
        </ProtectedRoute>
      } />
      
      <Route path="/gestao/contratos/:id" element={
        <ProtectedRoute requireAdmin={true}>
          <ContratoDetalhes />
        </ProtectedRoute>
      } />
      
      <Route path="/dashboard/contratos" element={
        <ProtectedRoute requireAdmin={true}>
          <ContratosDashboard />
        </ProtectedRoute>
      } />

      <Route path="/dashboard/meus-contratos" element={
        <ProtectedRoute>
          <DashboardCliente />
        </ProtectedRoute>
      } />

      <Route path="/dashboard/creditos" element={
        <ProtectedRoute>
          <DashboardCreditos />
        </ProtectedRoute>
      } />

      <Route path="/upgrade-plano" element={
        <ProtectedRoute>
          <UpgradePlano />
        </ProtectedRoute>
      } />

      <Route path="/selecionar-cartao-upgrade" element={
        <ProtectedRoute>
          <SelecionarCartaoUpgrade />
        </ProtectedRoute>
      } />

      <Route path="/comprar-creditos" element={
        <ProtectedRoute>
          <ComprarCreditos />
        </ProtectedRoute>
      } />

      <Route path="/cliente-sobre" element={
        <ProtectedRoute>
          <ClienteSobre />
        </ProtectedRoute>
      } />

      <Route path="/cliente-sobre/novo" element={
        <ProtectedRoute>
          <ClienteSobreForm />
        </ProtectedRoute>
      } />

      <Route path="/cliente-sobre/:id/editar" element={
        <ProtectedRoute>
          <ClienteSobreForm />
        </ProtectedRoute>
      } />
      
      <Route path="/clientes" element={
        <ProtectedRoute requireAdmin={true}>
          <Clientes />
        </ProtectedRoute>
      } />
      
      <Route path="/clientes/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <ClienteForm />
        </ProtectedRoute>
      } />
      
      <Route path="/clientes/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <ClienteForm />
        </ProtectedRoute>
      } />
      
      <Route path="/administracao/keys-apis" element={
        <ProtectedRoute requireAdmin={true}>
          <KeysApis />
        </ProtectedRoute>
      } />
      
      <Route path="/administracao/keys-apis/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <KeyApiForm />
        </ProtectedRoute>
      } />
      
      <Route path="/administracao/keys-apis/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <KeyApiForm />
        </ProtectedRoute>
      } />

      <Route path="/leads/preparar-mensagens" element={
        <ProtectedRoute requireAdmin={true}>
          <LeadsPrepararMensagens />
        </ProtectedRoute>
      } />

      <Route path="/leads/preparar-mensagens/confirmar-envio" element={
        <ProtectedRoute requireAdmin={true}>
          <LeadsConfirmarEnvio />
        </ProtectedRoute>
      } />

      <Route path="/leads/mensagens-etapa" element={
        <ProtectedRoute requireAdmin={true}>
          <MensagensEtapa />
        </ProtectedRoute>
      } />

      <Route path="/leads/mensagens-etapa/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <MensagemEtapaForm />
        </ProtectedRoute>
      } />

      <Route path="/leads/mensagens-etapa/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <MensagemEtapaForm />
        </ProtectedRoute>
      } />

      <Route path="/leads/funis" element={
        <ProtectedRoute requireAdmin={true}>
          <FunilProspeccao />
        </ProtectedRoute>
      } />

      <Route path="/leads/funis/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <FunilProspeccaoForm />
        </ProtectedRoute>
      } />

      <Route path="/leads/funis/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <FunilProspeccaoForm />
        </ProtectedRoute>
      } />

      <Route path="/leads" element={
        <ProtectedRoute requireAdmin={true}>
          <Leads />
        </ProtectedRoute>
      } />

      <Route path="/leads/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <LeadForm />
        </ProtectedRoute>
      } />

      <Route path="/leads/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <LeadFormEditar />
        </ProtectedRoute>
      } />

      <Route path="/campanhas" element={
        <ProtectedRoute>
          <Campanhas />
        </ProtectedRoute>
      } />

      <Route path="/campanhas/novo" element={
        <ProtectedRoute>
          <CampanhaForm />
        </ProtectedRoute>
      } />

      <Route path="/campanhas/:id/editar" element={
        <ProtectedRoute>
          <CampanhaForm />
        </ProtectedRoute>
      } />

      <Route path="/parametros-ia" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametrosIA />
        </ProtectedRoute>
      } />

      <Route path="/parametros-ia/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametroIAForm />
        </ProtectedRoute>
      } />

      <Route path="/parametros-ia/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametroIAForm />
        </ProtectedRoute>
      } />

      <Route path="/configuracao-ia" element={
        <ProtectedRoute requireGestorOnly={true}>
          <ConfiguracaoIA />
        </ProtectedRoute>
      } />

      <Route path="/configuracao-ia/:id/editar" element={
        <ProtectedRoute requireGestorOnly={true}>
          <ConfiguracaoIAForm />
        </ProtectedRoute>
      } />

      <Route path="/parametros-whatsapp" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametrosWhatsapp />
        </ProtectedRoute>
      } />

      <Route path="/parametros-whatsapp/novo" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametroWhatsappForm />
        </ProtectedRoute>
      } />

      <Route path="/parametros-whatsapp/:id/editar" element={
        <ProtectedRoute requireAdmin={true}>
          <ParametroWhatsappForm />
        </ProtectedRoute>
      } />
      
      {/* Rota padrão - redireciona baseado no tipo de usuário */}
      <Route path="/" element={
        <ProtectedRoute>
          <RedirectAuth />
        </ProtectedRoute>
      } />
      
      {/* Rota catch-all - redireciona baseado no tipo de usuário */}
      <Route path="*" element={
        <ProtectedRoute>
          <RedirectAuth />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
